import Mensagem from './componentes/Mensagem.vue';
import SolicitacaoCompraRelatorio from '~modulos/solicitacao-compra/componentes/SolicitacaoCompraRelatorio.vue';

export default {
  path: '/mensagem',
  component: Mensagem,
  meta: { auth: true },
  name: 'mensagem',
  children: [
    {
      path: '/solicitacao-compra/:id/relatorio',
      component: SolicitacaoCompraRelatorio,
      name: 'mensagem-compra.relatorio'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/mensagem/rotas.js